import React from 'react';

const error =(props) => {
    return (
        <p>Sorry cant find city named that way.Try agian</p>
    )
};

export default error;


// WEBPACK FOOTER //
// ./src/components/Error/Error.js